// src/components/BottomBar.js
import {
  AppBar,
  Toolbar,
  Container,
  Stack,
  Snackbar,
  Alert,
} from "@mui/material";
import AddToCart from "./AddToCart";
import { useData } from "../hooks/useData";

const BottomBar = () => {
  const { snackbar, setSnackbar } = useData();

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <AppBar
      position="fixed"
      color="default"
      sx={{
        top: "auto",
        bottom: 0,
        backgroundColor: "background.paper", // Use theme's background.paper
        boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.1)",
        height: 64,
      }}
    >
      <Toolbar
        sx={{
          height: "100%",
          minHeight: "64px !important",
          display: "flex",
          alignItems: "center",
          padding: "0 16px",
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            display: "flex",
            justifyContent: "flex-end", // Align content to the right
            alignItems: "center",
            width: "100%",
            height: "100%",
            position: "relative", // Allow absolute positioning of Snackbar
          }}
        >
          {/* Snackbar positioned absolutely */}
          <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "left" }} // Position above BottomBar
            sx={{
              position: "absolute",
              top: -48, // Place above the BottomBar (adjust as needed)
              left: 16,
              zIndex: 1400, // Ensure it appears above other elements
              "& .MuiSnackbarContent-root": {
                minWidth: "auto",
                padding: "4px 8px",
                fontSize: "0.875rem",
                lineHeight: "1.25rem",
                maxHeight: "40px",
                display: "flex",
                alignItems: "center",
              },
            }}
          >
            <Alert
              onClose={handleCloseSnackbar}
              severity={snackbar.severity || "info"}
              sx={{
                padding: "2px 8px",
                fontSize: "0.875rem",
                lineHeight: "1.25rem",
                display: "flex",
                alignItems: "center",
                maxHeight: "40px",
              }}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>

          {/* AddToCart pinned to the right */}
          <Stack direction="row" spacing={2} alignItems="center">
            <AddToCart />
          </Stack>
        </Container>
      </Toolbar>
    </AppBar>
  );
};

export default BottomBar;
